var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5002 57.8226C15.4281 57.8226 3.17725 45.5718 3.17725 30.4997C3.17725 15.4276 15.4281 3.17676 30.5002 3.17676C45.5722 3.17676 57.8231 15.4276 57.8231 30.4997C57.8231 45.5718 45.5722 57.8226 30.5002 57.8226ZM30.5002 6.98926C17.5377 6.98926 6.98975 17.5372 6.98975 30.4997C6.98975 43.4622 17.5377 54.0101 30.5002 54.0101C43.4627 54.0101 54.0106 43.4622 54.0106 30.4997C54.0106 17.5372 43.4627 6.98926 30.5002 6.98926Z",
    fill: "#FCB450"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 34.9476C29.4579 34.9476 28.5938 34.0834 28.5938 33.0413V20.333C28.5938 19.2909 29.4579 18.4268 30.5 18.4268C31.5421 18.4268 32.4062 19.2909 32.4062 20.333V33.0413C32.4062 34.0834 31.5421 34.9476 30.5 34.9476Z",
    fill: "#FCB450"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5002 43.2083C30.1697 43.2083 29.8393 43.1321 29.5343 43.005C29.2293 42.8779 28.9497 42.7 28.6956 42.4712C28.4668 42.2171 28.2889 41.9629 28.1618 41.6325C28.0347 41.3275 27.9585 40.9971 27.9585 40.6667C27.9585 40.3362 28.0347 40.0058 28.1618 39.7008C28.2889 39.3958 28.4668 39.1162 28.6956 38.8621C28.9497 38.6333 29.2293 38.4554 29.5343 38.3283C30.1443 38.0742 30.856 38.0742 31.466 38.3283C31.771 38.4554 32.0506 38.6333 32.3047 38.8621C32.5335 39.1162 32.7114 39.3958 32.8385 39.7008C32.9656 40.0058 33.0418 40.3362 33.0418 40.6667C33.0418 40.9971 32.9656 41.3275 32.8385 41.6325C32.7114 41.9629 32.5335 42.2171 32.3047 42.4712C32.0506 42.7 31.771 42.8779 31.466 43.005C31.161 43.1321 30.8306 43.2083 30.5002 43.2083Z",
    fill: "#FCB450"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmImage);
export default __webpack_public_path__ + "static/media/confirm-image.466520169afcd65f4590101490011d6b.svg";
export { ForwardRef as ReactComponent };